/* import __COLOCATED_TEMPLATE__ from './refocus-nodes.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import type Graph from '../../../models/graph-editor/graph';
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsRefocusNodesComponent extends Component<Args> {
  @action refocusNodes(): void {
    let nodes = this.args.graph.nodes.toArray();
    if (isPresent(nodes)) {
      this.args.graph.focusNode(nodes[0]);
    }
  }
}
